import React from "react";

const QrCodeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2925_1388)">
        <path
          d="M12.9927 9.9945V12.9927M9.9945 1V3.99817M15.9908 9.9945V12.9927M9.9945 15.9908H18.989M15.9908 18.989H18.989M3.99817 9.9945H6.99634M3.99817 4.00916L4.00816 3.99817M9.9945 10.0055L10.0045 9.9945M1 10.0055L1.00999 9.9945M9.9945 7.00733L10.0045 6.99634M9.9945 13.0037L10.0045 12.9927M12.9927 19L13.0027 18.989M9.9945 19L10.0045 18.989M18.989 10.0055L18.999 9.9945M18.989 13.0037L18.999 12.9927M15.9908 4.00916L16.0008 3.99817M3.99817 16.0018L4.00816 15.9908M6.99634 1.59963V6.3967C6.99634 6.55573 6.93316 6.70825 6.82071 6.82071C6.70825 6.93316 6.55573 6.99634 6.3967 6.99634H1.59963C1.4406 6.99634 1.28808 6.93316 1.17563 6.82071C1.06318 6.70825 1 6.55573 1 6.3967V1.59963C1 1.4406 1.06318 1.28808 1.17563 1.17563C1.28808 1.06318 1.4406 1 1.59963 1H6.3967C6.55573 1 6.70825 1.06318 6.82071 1.17563C6.93316 1.28808 6.99634 1.4406 6.99634 1.59963ZM18.989 1.59963V6.3967C18.989 6.55573 18.9258 6.70825 18.8134 6.82071C18.7009 6.93316 18.5484 6.99634 18.3894 6.99634H13.5923C13.4333 6.99634 13.2808 6.93316 13.1683 6.82071C13.0558 6.70825 12.9927 6.55573 12.9927 6.3967V1.59963C12.9927 1.4406 13.0558 1.28808 13.1683 1.17563C13.2808 1.06318 13.4333 1 13.5923 1H18.3894C18.5484 1 18.7009 1.06318 18.8134 1.17563C18.9258 1.28808 18.989 1.4406 18.989 1.59963ZM6.99634 13.5923V18.3894C6.99634 18.5484 6.93316 18.7009 6.82071 18.8134C6.70825 18.9258 6.55573 18.989 6.3967 18.989H1.59963C1.4406 18.989 1.28808 18.9258 1.17563 18.8134C1.06318 18.7009 1 18.5484 1 18.3894V13.5923C1 13.4333 1.06318 13.2808 1.17563 13.1683C1.28808 13.0558 1.4406 12.9927 1.59963 12.9927H6.3967C6.55573 12.9927 6.70825 13.0558 6.82071 13.1683C6.93316 13.2808 6.99634 13.4333 6.99634 13.5923Z"
          stroke="#E4E4E2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2925_1388">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default QrCodeIcon;
